import { render, staticRenderFns } from "./TitledContainer.vue?vue&type=template&id=4fa62966&"
import script from "./TitledContainer.vue?vue&type=script&lang=js&"
export * from "./TitledContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports